import script from "./BannerField.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerField.vue?vue&type=script&setup=true&lang=js"

export default script